import { Colors } from "../../../utils/colors";
import {
  AccountData,
  Event,
  FormResponseV2,
  SavedFormQuestion,
} from "@markit/common.types";
import React, { useState } from "react";
import PopupModalContainer from "../../Containers/PopupModalContainer";
import FlatList from "flatlist-react/lib";
import { FormResponseContainer } from "../FormResponseContainer";
import { getUserFormResponseData } from "../../../utils/FirebaseUtils";
import { getEventFormQuestions } from "../../../utils/eventUtils/formUtils";
import { DotWave } from "@uiball/loaders";
import useAsyncOnMount from "../../../hooks/useAsyncEffectOnMount";
import { ContainerButton } from "../../Buttons/ContainerButton";
import { LightTheme } from "../../../hooks/useTheme";

type FormResponsesModalProps = {
  event: Event;
  profileData: AccountData;
  setIsVisible: (isVisible: boolean) => void;
};

export const FormResponsesModal = (props: FormResponsesModalProps) => {
  const { event, profileData, setIsVisible } = props;
  const [formQuestions, setFormQuestions] = useState<SavedFormQuestion[]>([]);
  const [formResponse, setFormResponse] = useState<FormResponseV2>();
  const [loading, setLoading] = useState(true);

  useAsyncOnMount(async () => {
    const [formResponse, formQuestions] = await Promise.all([
      getUserFormResponseData(event.id, profileData.uid),
      getEventFormQuestions(event),
    ]);
    setFormResponse(formResponse);
    setFormQuestions(formQuestions);
    setLoading(false);
  });

  return (
    <PopupModalContainer
      headerComp={
        <div className="AlignedRow" style={{ gap: 10 }}>
          <ContainerButton
            onPress={() => setIsVisible(false)}
            theme={LightTheme}
            iconName={"ion:chevron-back"}
            iconSize={18}
            containerStyles={{ width: 31, height: 31, padding: 0 }}
          />
          <div>{profileData.fullName}&apos;s Form Responses</div>
        </div>
      }
      valueComp={
        <div
          className="ColumnNormal HideScrollbar"
          style={{ height: "70vh", overflow: "scroll", gap: 14 }}
        >
          {loading ? (
            <DotWave size={28} speed={1} color={Colors.BLACK} />
          ) : (
            <FlatList
              list={formQuestions}
              keyExtractor={(item: SavedFormQuestion) => item.id}
              renderItem={(item) => {
                return (
                  <FormResponseContainer
                    eventId={event.id}
                    item={item}
                    individualUserResponse={formResponse}
                    setIndividualUserResponse={setFormResponse}
                    clicked={true}
                    onPress={() => {}}
                  />
                );
              }}
            />
          )}
        </div>
      }
      noExit
      closeModal={() => setIsVisible(false)}
    />
  );
};
